import pick from 'lodash/pick';
import dayjs from 'dayjs';

const getSettings = (assignment = {}) => {
  let settings = pick(assignment, [
    'print_toggle',
    'score_display',
    'starts_at',
    'due_at',
    'timer',
    'scramble_questions',
    'is_secure',
    'attestation_agreement_checked',
  ]);
  const { timezone = 'US/Eastern' } = assignment;

  if (settings.starts_at) {
    let { starts_at } = settings;
    starts_at = dayjs(starts_at).tz(timezone).utcOffset(0, true);
    settings.starts_at = starts_at.format('YYYY-MM-DD HH:mm');
  }

  if (settings.due_at) {
    let { due_at } = settings;
    due_at = dayjs(due_at).tz(timezone).utcOffset(0, true);
    settings.due_at = due_at.format('YYYY-MM-DD HH:mm');
  }

  return settings;
};

export default getSettings;
